import {
  SerializeMap,
  buildDeserializer,
  buildSerializer,
} from "lib/serializerUtils";

const xeroTrackingCategoryOptionSerializeMap: SerializeMap<XeroTrackingCategoryOption> =
  {
    id: "id",
    trackingOptionId: "tracking_option_id",
    name: "name",
    status: "status",
  };

const xeroTrackingCategorySerializeMap: SerializeMap<XeroTrackingCategory> = {
  id: "id",
  trackingCategoryId: "tracking_category_id",
  name: "name",
  status: "status",
  options: xeroTrackingCategoryOptionSerializeMap,
};

export const serializeXeroTrackingCategory = buildSerializer(
  xeroTrackingCategorySerializeMap,
  "xeroTrackingCategory",
);
export const deserializeXeroTrackingCategory = buildDeserializer(
  xeroTrackingCategorySerializeMap,
  "xeroTrackingCategory",
);
